import api from './request'

const findSkuById = (skuId, platform) => {
    return api.postPromise('sku/utility/findSkuById', {skuId, platform})
}


export default {
    findSkuById
}



// WEBPACK FOOTER //
// ./src/request/skuUtiltiyApi.js